import React, { Component } from "react";
import Helmet from "react-helmet";
import configFile from "../../settings";

const SEO = ({ pageName }) => {
  const config = configFile.site;
  const title = `${config.title} ${config.subtitle}`;
  const altTitle  = `${title} — ${config.caption}`;
  const description = config.description;
  const realPrefix = config.pathPrefix === '/' ? '' : config.pathPrefix;
  const image = config.url + realPrefix + config.siteLogo;
  const logo = config.url + realPrefix + config.siteLogo;
  const realURL = config.url + config.pathPrefix;

  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org/",
      "@type": "CafeOrCoffeeShop",
      "url": realURL,
      "name": title,
      "alternateName": altTitle,
      "description": description,
      "currenciesAccepted": "EUR",
      "priceRange": "€€",
      "servesCuisine": "coffee",
      "telephone": "000",
      "paymentAccepted": "cash",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "Spain",
        "addressRegion": "Catalonia",
        "postalCode": "17001",
        "streetAddress": "Girona"
      },
      "email": "info@thebroomwagongirona.com",
      "founder": {
        "@type": "Person",
        "familyName": "Gesink",
        "givenName": "Robert",
        "jobTitle": "Pro Cyclist",
        "name": "Robert Gesink"
      },
      "image": image,
      "logo": logo,
    }
  ];
  return (
    <Helmet>
      <html lang={config.siteLanguage} />
      <title>{altTitle}</title>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      {/*<link rel="canonical" href={config.url + pageName} />*/}
      <script type="application/ld+json">{JSON.stringify(schemaOrgJSONLD)}</script>
      <meta property="og:site_name" content={altTitle} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;


// WEBPACK FOOTER //
// ./src/components/SEO.js